import { StandardEvents } from '@shopify/events';

/**
 * Lazily loads the cart drawer's "Recommended for you" strip via the Section Rendering API.
 * Re-fetches whenever the cart lines change so the recommendations follow the cart's contents.
 */
class CartRecommendations extends HTMLElement {
  #lastProductId = null;

  connectedCallback() {
    this.#load();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#load);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#load);
  }

  #load = async (event) => {
    // Wait for the cart section to finish re-rendering so data-product-id is current.
    await event?.promise?.catch(() => {});

    const productId = this.dataset.productId;
    const url = this.dataset.url;

    if (!productId || !url) {
      this.innerHTML = '';
      return;
    }

    // The strip only changes when the anchor product does, so skip redundant fetches.
    if (productId === this.#lastProductId && this.childElementCount > 0) return;
    this.#lastProductId = productId;

    try {
      const params = new URLSearchParams({
        section_id: 'cart-recommendations',
        product_id: productId,
        limit: this.dataset.limit || '10',
      });
      const response = await fetch(`${url}?${params}`);
      if (!response.ok) throw new Error(response.statusText);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      this.innerHTML = html.querySelector('.cart-recs')?.outerHTML ?? '';
    } catch (error) {
      console.warn('[cart-recommendations] Failed to load recommendations:', error);
      this.innerHTML = '';
    }
  };
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}
